import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(productImageStyles, {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column-reverse;
            width: 100%;
            padding: 10px 10px 10px 10px;
        `,
    },
    compareCheckbox: {
        css: css`
            align-self: flex-start;
            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background: #fff;
                border: 1px solid #bebdbd;
                color: #19a3e0;
            }
            span[role="checkbox"]:focus {
                outline: none;
                box-shadow: 0 0 0 1px #e2e3e6;
            }

            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        span[role="checkbox"] + label {
                            font-size: 12px;
                            margin-left: 8px;
                        }
                    `,
                    css`
                        span[role="checkbox"] + label {
                            font-size: 14px;
                            margin-left: 9px;
                        }
                    `,
                    css`
                        span[role="checkbox"] + label {
                            font-size: 14px;
                            margin-left: 9px;
                        }
                    `,
                    css`
                        span[role="checkbox"] + label {
                            font-size: 15px;
                            margin-left: 9px;
                        }
                    `,
                    css`
                        span[role="checkbox"] + label {
                            font-size: 16px;
                            margin-left: 10px;
                        }
                    `,
                ])},
        `,
    },
    productImage: {
        image: {
            width: "100%",
            css: css`
                img {
                    min-width: 100%;
                }
            `,
        },
    },
});
